import React, { useState } from "react";

export default function FAQ() {
  const [activeSection, setActiveSection] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      q: "What is the Kostya Live Event?",
      a: "Kostya Live is an exclusive in-person masterclass in Mumbai where you’ll learn advanced volume styling techniques, modern trends, and real-world client conversion strategies from an international expert."
    },
    {
      q: "Who should attend this event?",
      a: "Professional hairstylists, salon owners, hair educators, and serious learners looking to upgrade their skills."
    },
    {
      q: "What will I learn?",
      a: "Advanced volume styling, trending looks, speed & precision methods, and client pricing strategies."
    },
    {
      q: "Where is the event happening?",
      a: "The event will take place in Mumbai. Exact venue details will be shared after registration."
    },
    {
      q: "What is the duration?",
      a: "Approximately 4 hours including demonstrations."
    },
    {
      q: "Will I get a certificate?",
      a: "Yes, all participants will receive a participation certificate."
    },
    {
      q: "Is this hands-on?",
      a: "No, this is a look & learn masterclass."
    },
    {
      q: "Are tickets transferable?",
      a: "Only with prior approval from the organizer."
    },
    {
      q: "Will I get recording?",
      a: "No, recordings are not provided."
    },
    {
      q: "How can I contact support?",
      a: "You can reach via WhatsApp or DM."
    }
  ];

  return (
    <div className="faq-section">

      {/* TOP BUTTONS */}
      <div
        className="faq-toggle"
        onClick={() =>
          setActiveSection(activeSection === "faq" ? null : "faq")
        }
      >
        <span>💬 frequently asked questions</span>
        <span>›</span>
      </div>

      {activeSection === "faq" && (
        <div className="faq-content">
          {faqData.map((item, i) => (
            <div key={i} className="faq-item">
              <div
                className="faq-question"
                onClick={() =>
                  setActiveIndex(activeIndex === i ? null : i)
                }
              >
                {item.q}
                <span>{activeIndex === i ? "−" : "+"}</span>
              </div>

              {activeIndex === i && (
                <div className="faq-answer">{item.a}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}